import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {ScrollMode, SpecialZoomLevel, Viewer, Worker} from "@react-pdf-viewer/core";
import {getFilePlugin} from "@react-pdf-viewer/get-file";
import {pageNavigationPlugin} from "@react-pdf-viewer/page-navigation";
import {printPlugin} from "@react-pdf-viewer/print";
import {toolbarPlugin} from "@react-pdf-viewer/toolbar";
import {read, utils} from "xlsx";

import {apiUrl} from "../../../../api/baseURL";
//import prevIcon from "../../../../images/icons/Caret_Circle_Left.png";
//import nextIcon from "../../../../images/icons/Caret_Circle_Right.png";
import CloseBtn from "../../../../utilities/Buttons/CloseBtn";
import DownloadBtn from "../../../../utilities/Buttons/DownloadBtn";
import IconButton from "../../../../utilities/Buttons/IconButton";
import ShareButton from "../../../../utilities/Buttons/ShareButton";
import {COLOR_SCHEME} from "../../../../utilities/colorSheme";
import {ICON_NAMES} from "../../../../utilities/generalConstants.js/generalConstants";
import ToolTip from "../../../../utilities/ToolTip";
import {UI_PERMISSION_TYPE} from "../../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import Icon from "../../../Icon/Icon";
import PdfFilePreview from "../../../Inputs/fileSelect/preview/PdfPreview";
import ImgSlider from "../../../Inputs/fileSelect/slider/NewImgSlider";
import Modal from "../../../Modal/Modal";
import Spinner from "../../../spinner/Spinner";

//import nextDocIcon from "./src/next-doc.png";
//import prevDocIcon from "./src/prev-doc.png";
import WaterMark from "./src/WaterMark";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import "@react-pdf-viewer/print/lib/styles/index.css";
import "./src/DocumentView.scss";

//* Для добавления шейр функционала
// shareBtnEnable
// entityId={currentCof?.cofId}
// entityName="cof"
// fileName={currentCof?.cofNumber}

const NewPdfViewer = ({
  fileArray,
  rotate = 0,
  hiding = true,
  setHiding = () => {},
  printBtnEnable,
  shareBtnEnable = false,
  onlyLocalFile = false,
  format = null,
  className,
  isDownloadDisabled = false,
  waterMarkShow = false,
  waterMarkText = "NOT FOR PRINT",
  waterMarkColor,
  waterMarkStyle = {},
  onViewBtnClick = () => {},
  needToUpdate = false, //show, that the doc is deprecated,
  showEmptyStateIcon = false, //показувати іконку пустого стану, якщо даних немає,
  iconsInViewField = true, //показувати іконки навігації та інші кнопки в полі перегляду документу, чи ні (якщо ні - показувати їх в окремій панелі поза полем перегляду внизу)
  iconsBottomPosition, //позиція панелі з іконками відносно низу поля перегляду
  noInDocPageNavigation = false, //remove in doc page navigation buttons (GoToPreviousPage, GoToNextPage), leave only docs navigation (prevFile, nextFile)
  withPreview = false, //with PdfFilePreview component to add or delete files
  onAddFile,
  onDeleteFile,
  onRestoreFile,
  previewDisabled,
  previewSingleFile,
  previewAccept = ".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg",
  noFunctional = false,
  defaultScaleIncr, //scale for pdf viewer
  entityId, //* for share functional
  entityName,
  fileName,
}) => {
  const iconsBottomPositionValue = iconsBottomPosition || iconsInViewField ? "1rem" : "-2rem";
  const {t} = useTranslation();

  const [file, setFile] = useState(null);
  const fileUrl = file?.split("|")?.at(0);
  const isFileDeleted = file?.includes("|DELETED");
  if (isFileDeleted) {
    waterMarkShow = true;
    waterMarkText = "Deleted";
    waterMarkColor = COLOR_SCHEME.ALERT;
  }
  const [showModal, setShowModal] = useState(false);
  const [showFile, setShowFile] = useState(!hiding);
  const [numFiles, setNumFiles] = useState(0);
  const [prevFileDis, setPrevFileDis] = useState(true);
  const [nextFileDis, setNextFileDis] = useState(true);
  const [fileType, setFileType] = useState();

  const disabledViewBtn = fileArray && fileArray?.length !== 0 ? false : true;

  const currentFileFormat = file?.split("|")?.at(0)?.split(".")?.at(-1)?.toUpperCase();
  function calcFileType(currentFileFormat) {
    if (currentFileFormat === "PDF" || currentFileFormat === "XLS" || currentFileFormat === "XLSX") {
      return currentFileFormat;
    } else {
      return "IMG";
    }
  }

  useEffect(() => {
    if (!fileArray?.length) return;

    if (format) {
      setFileType(format);
    } else {
      setFileType(calcFileType(currentFileFormat));
    }
  }, [format, currentFileFormat, fileArray?.length]);

  useEffect(() => {
    if (hiding) {
      setFile(null);
      setShowFile(false);
    }
    if (fileArray && fileArray.length !== 0) {
      // let f = fileArray[0]?.split(".");
      setNumFiles(0);

      //  let calculatedFormat = f[f.length - 1].toUpperCase();

      //  if (format) {
      //    setFileType(format);
      //  } else if (calculatedFormat === "PDF" || calculatedFormat === "XLS" || calculatedFormat === "XLSX") {
      //    setFileType(calculatedFormat);
      //  } else setFileType("IMG");
      if (!hiding) {
        changeFile(fileArray[0]);
        setShowFile(true);
      }
    } else if (fileArray?.length < 1 && !hiding) {
      setFile(null);
    }
  }, [fileArray, hiding]);

  useEffect(() => {
    setNumFiles(0);
    if (showFile) {
      if (!file) {
        changeFile(fileArray[numFiles]);
      } //demoPdf
    } else {
      setNextFileDis(true);
      setPrevFileDis(true);
    }
  }, [showFile]);

  const changeFile = file => {
    if (!file) return;
    setFile(onlyLocalFile ? file : `${apiUrl}/${file}`);
    if (fileArray.length > 1 && numFiles !== fileArray.length - 1) setNextFileDis(false);
  };

  const showNextFile = () => {
    if (numFiles !== fileArray.length - 1) setNumFiles(num => (num = num + 1));
  };
  const showPrevFile = () => {
    if (numFiles !== 0) setNumFiles(num => (num = num - 1));
  };

  useEffect(() => {
    if (file) {
      if (numFiles === 0) setPrevFileDis(true);
      if (numFiles === fileArray.length - 1) setNextFileDis(true);
      if (numFiles < fileArray.length - 1) setNextFileDis(false);
      if (numFiles > 0 && numFiles <= fileArray.length - 1) setPrevFileDis(false);

      changeFile(fileArray[numFiles]);
    }
  }, [numFiles]);

  const renderFunc = fileType => {
    switch (fileType) {
      case "PDF":
        if (showModal) return <RenderFullScreenPdf file={fileUrl} />;
        else {
          return (
            <RenderPdfViewer
              fileArray={fileArray}
              file={fileUrl}
              prevFileDis={prevFileDis}
              showPrevFile={showPrevFile}
              nextFileDis={nextFileDis}
              showNextFile={showNextFile}
              rotate={rotate}
              printBtnEnable={printBtnEnable}
              shareBtnEnable={shareBtnEnable}
              isDownloadDisabled={isDownloadDisabled}
              needToUpdate={needToUpdate}
              iconsBottomPositionValue={iconsBottomPositionValue}
              noInDocPageNavigation={noInDocPageNavigation}
              defaultScaleIncr={defaultScaleIncr}
              entityId={entityId}
              entityName={entityName}
              fileName={fileName}
            />
          );
        }
      case "IMG":
        return (
          <RenderImgFilesViewer
            file={fileUrl}
            prevFileDis={prevFileDis}
            showPrevFile={showPrevFile}
            nextFileDis={nextFileDis}
            showNextFile={showNextFile}
            isDownloadDisabled={isDownloadDisabled}
            iconsBottomPositionValue={iconsBottomPositionValue}
            printBtnEnable={printBtnEnable}
          />
        );
      case "XLS":
      case "XLSX":
        return (
          <RenderExcelFilesViewer
            fileUrl={fileUrl}
            prevFileDis={prevFileDis}
            showPrevFile={showPrevFile}
            nextFileDis={nextFileDis}
            showNextFile={showNextFile}
            isDownloadDisabled={isDownloadDisabled}
          />
        );
      default:
        return null;
    }
  };

  const renderModalFunc = fileType => {
    switch (fileType) {
      case "PDF":
        return (
          // <div style={{width: "70vw", maxHeight: "80vh"}}>
          <RenderFullScreenPdf
            file={fileUrl}
            isDownloadDisabled={isDownloadDisabled}
            waterMarkText={t(waterMarkText)}
            waterMarkShow={waterMarkShow}
            waterMarkColor={waterMarkColor}
            needToUpdate={needToUpdate}
          />
          // </div>
        );
      case "IMG":
        return <ImgSlider imgs={fileArray} width={"100%"} height={"100%"} />;
      case "XLS":
      case "XLSX":
        return (
          <RenderExcelFilesViewer
            className="w100 h100"
            controlBarStyle={{bottom: "10px"}}
            fileUrl={fileUrl}
            prevFileDis={prevFileDis}
            showPrevFile={showPrevFile}
            nextFileDis={nextFileDis}
            showNextFile={showNextFile}
            isDownloadDisabled={isDownloadDisabled}
          />
        );
      default:
        return null;
    }
  };

  return (
    <ToolTip
      title={needToUpdate ? "The documents needs to be updated" : ""}
      className={`doc_view ${className}`}
      style={{...(needToUpdate ? {border: `2px solid ${COLOR_SCHEME.ALERT_BRIGHT}`} : {})}}
    >
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <div className="doc_view__container" style={{position: "absolute"}}>
          {!showModal && showFile && file && renderFunc(fileType)}
          {!file && showEmptyStateIcon && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: "#5565a3",
                pointerEvents: "none",
                padding: "0 1rem",
                opacity: 0.7,
              }}
            >
              <Icon name={ICON_NAMES.DOC_ERROR} className="icon-react-table" width={60} height={60} />
              <span>{t("No Data")}</span>
            </div>
          )}
        </div>
        {waterMarkShow && showFile && (
          <WaterMark text={t(waterMarkText)} style={{color: waterMarkColor, ...waterMarkStyle}} />
        )}
        <div className="doc_view__options pl" style={{bottom: iconsBottomPositionValue}}>
          {
            hiding && (
              // (disabledViewBtn ? (
              <IconButton
                nameIcon={needToUpdate ? ICON_NAMES.ALERT_TRIANGLE : showFile ? ICON_NAMES.EYE : ICON_NAMES.EYE_OFF}
                disabled={disabledViewBtn}
                onClick={() => {
                  setShowFile(i => (i = !i));
                  onViewBtnClick();
                  setHiding(prev => !prev);
                }}
                tooltipMessage={
                  needToUpdate
                    ? "The documents needs to be updated"
                    : disabledViewBtn
                    ? ""
                    : showFile
                    ? "Close document"
                    : "Open document"
                }
                classNameIcon={needToUpdate ? "icon-error" : ""}
                uiPermissionType={UI_PERMISSION_TYPE.READABLE}
              />
            )
            // ) : (
            // <ImageButton
            //   src={showFile ? (needToUpdate ? showIconAlert : showIcon) : needToUpdate ? hideIconAlert : hideIcon}
            //   alt="hide doc"
            //   width={1.5}
            //   height={1.5}
            //   disabled={disabledViewBtn}
            //   onClick={() => {
            //     setShowFile(i => (i = !i));
            //     onViewBtnClick();
            //     setHiding(prev => !prev);
            //   }}
            //   className="doc_view__visibility"
            //   tooltipMessage={needToUpdate ? "The documents needs to be updated" : ""}
            // />
            // <ImageButton
            //   src={showFile ? (needToUpdate ? showIconAlert : showIcon) : needToUpdate ? hideIconAlert : hideIcon}
            //   alt="hide doc"
            //   width={1.5}
            //   height={1.5}
            //   disabled={disabledViewBtn}
            //   onClick={() => {
            //     setShowFile(i => (i = !i));
            //     onViewBtnClick();
            //     setHiding(prev => !prev);
            //   }}
            //   className="doc_view__visibility"
            //   tooltipMessage={
            //     needToUpdate ? "The documents needs to be updated" : showFile ? "Close document" : "Open document"
            //   }
            // />
            // )
            // )
          }

          {showFile && fileArray?.length > 0 && (
            <IconButton
              nameIcon={ICON_NAMES.EXPAND}
              widthIcon={20}
              heightIcon={20}
              ariaLabel="View file in full width"
              disabled={file && fileArray && fileArray.length !== 0 ? false : true}
              onClick={() => {
                setShowModal(i => (i = !i));
              }}
              tooltipMessage="Full screen"
              uiPermissionType={UI_PERMISSION_TYPE.READABLE}
            />
          )}
          {showModal && (
            <Modal active={showModal} setActive={setShowModal} height="90vh" width="90vw">
              <CloseBtn
                style={{top: "0.5em", right: "0.4em"}}
                onClick={() => {
                  setShowModal(false);
                }}
              />
              <div className="fcCol aistr jcst fGrow w100">{showFile && file && renderModalFunc(fileType)}</div>
            </Modal>
          )}
          {showFile && withPreview && (
            <PdfFilePreview
              files={fileArray || []}
              addFunc={onAddFile}
              delFunc={onDeleteFile}
              restoreFunc={onRestoreFile}
              accept={previewAccept}
              singleFile={previewSingleFile}
              disabled={previewDisabled || noFunctional}
              tooltipMessage={noFunctional ? "No functional" : ""}
              isIconChangedIfFileUploaded={false}
            />
          )}
          {/* <div className="doc_view__download">
                    <p>download</p><img src={downloadIcon} alt="download" />
                </div> */}
          {/* <img src={printIcon} alt="print" /> */}
        </div>
      </Worker>
    </ToolTip>
  );
};

const RenderImgFilesViewer = props => {
  // const {t} = useTranslation();
  const {file, prevFileDis, showPrevFile, nextFileDis, showNextFile, iconsBottomPositionValue} = props;
  const print = url => {
    const win = window.open("");
    win.document.write(`
    <html>
      <head>
        <style>
          * { margin: 0; padding: 0; }
          body { visibility: hidden; }
          img { width: 100%; height: auto; }
          @media print {
            body { visibility: visible; }
            img { width: 100%; }
          }
        </style>
      </head>
      <body>
        <img src="${url}" onload="window.print(); window.close();" />
      </body>
    </html>
  `);
    win.document.close();
  };

  return (
    <>
      <div className="image_container_project-doc">
        <img src={file} alt="" draggable="false" style={{overflow: "hidden"}} />
      </div>
      <div className="page-control-bar" style={{bottom: iconsBottomPositionValue}}>
        <div className="page-control-bar__container gap">
          <IconButton
            ariaLabel="Go to previous document"
            nameIcon={ICON_NAMES.SHEVRONS_LEFT}
            disabled={prevFileDis}
            onClick={showPrevFile}
            classNameBtn="iconBtn-border"
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
          <IconButton
            ariaLabel="Go to next document"
            nameIcon={ICON_NAMES.SHEVRONS_RIGHT}
            disabled={nextFileDis}
            onClick={showNextFile}
            classNameBtn="iconBtn-border"
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
        </div>
      </div>
      {!props?.isDownloadDisabled && !props?.needToUpdate && (
        <div className="doc_view__download pdf pr" onClick={props.onClick} style={{bottom: iconsBottomPositionValue}}>
          <DownloadBtn url={file} />
        </div>
      )}

      {props?.printBtnEnable && !props?.needToUpdate && (
        <div
          className=""
          onClick={props.onClick}
          style={{position: "absolute", bottom: iconsBottomPositionValue, right: "4em", zIndex: "100"}}
        >
          <IconButton
            ariaLabel="Print"
            nameIcon={ICON_NAMES.PRINTER}
            tooltipMessage="Print"
            onClick={() => {
              print(file);
            }}
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
        </div>
      )}
    </>
  );
};

const RenderExcelFilesViewer = ({
  fileUrl,
  prevFileDis,
  showPrevFile,
  nextFileDis,
  showNextFile,
  className,
  controlBarStyle = {},
}) => {
  const [excelData, setExcelData] = useState(null);

  const handleFileUpload = async fileUrl => {
    if (!fileUrl) return;

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error(`Failed to fetch file: ${response.statusText}`);

      const arrayBuffer = await response.arrayBuffer();
      const data = new Uint8Array(arrayBuffer);

      const workbook = read(data, {type: "array"});
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = utils.sheet_to_json(worksheet, {header: 1});

      setExcelData(jsonData);
    } catch (error) {
      console.error("Error loading Excel file:", error);
      setExcelData(null);
    }
  };

  useEffect(() => {
    handleFileUpload(fileUrl);
  }, [fileUrl]);

  return (
    <>
      <div className={`image_container_project-doc h100 ${className}`}>
        {excelData ? (
          // <table>
          //   <tbody>
          //     {excelData.map((row, rowIndex) => (
          //       <tr key={rowIndex}>
          //         {row.map((cell, cellIndex) => (
          //           <td key={cellIndex}>{cell ?? ""}</td>
          //         ))}
          //       </tr>
          //     ))}
          //   </tbody>
          // </table>
          <div className="fcCol w100 h100 padding">
            {excelData.map((row, rowIndex) => (
              <div className="row w100" key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <div key={cellIndex}>{cell ?? ""}</div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          <p>No data to display</p>
        )}
      </div>
      <div className="page-control-bar" style={controlBarStyle}>
        <div className="page-control-bar__container">
          <IconButton
            ariaLabel="Go to previous page"
            nameIcon={ICON_NAMES.SHEVRON_LEFT}
            disabled={prevFileDis}
            onClick={showPrevFile}
            classNameBtn="iconBtn-border"
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
          <IconButton
            ariaLabel="Go to next page"
            nameIcon={ICON_NAMES.SHEVRON_RIGHT}
            disabled={nextFileDis}
            onClick={showNextFile}
            classNameBtn="iconBtn-border"
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
        </div>
      </div>
    </>
  );
};

const RenderPdfViewer = props => {
  // const {t} = useTranslation();

  const pageNavigationPluginInstance = pageNavigationPlugin();
  const {GoToNextPage, GoToPreviousPage} = pageNavigationPluginInstance;

  const getFilePluginInstance = getFilePlugin();
  const {Download} = getFilePluginInstance;

  const printPluginInstance = printPlugin();
  const {Print} = printPluginInstance;

  // const fullScreenPluginInstance = fullScreenPlugin();
  // const { EnterFullScreenButton, EnterFullScreenMenuItem } = fullScreenPluginInstance;

  const {
    file,
    prevFileDis,
    showPrevFile,
    nextFileDis,
    showNextFile,
    rotate,
    iconsBottomPositionValue,
    noInDocPageNavigation,
    defaultScaleIncr,
    fileArray,
    entityId,
    entityName,
    fileName,
  } = props;

  const renderError = ({message}) => {
    return <p className="label error_doc_view">{message}</p>;
  };

  return (
    <>
      <Viewer
        fileUrl={file}
        defaultScale={defaultScaleIncr ? SpecialZoomLevel.PageFit * defaultScaleIncr : SpecialZoomLevel.PageFit}
        scrollMode={ScrollMode.Vertical}
        plugins={[pageNavigationPluginInstance, getFilePluginInstance, printPluginInstance]}
        renderError={renderError}
        renderLoader={() => <Spinner />}
        rotate={rotate}

        //    markRendered={markRendered}
        // onPageChange={({currentPage})=>{console.log(currentPage)}}
        //    onDocumentLoad={handleDocumentLoad}
      />

      <div className="page-control-bar" style={{bottom: iconsBottomPositionValue}}>
        <div className="page-control-bar__container gap">
          <IconButton
            ariaLabel="Go to previous document"
            nameIcon={ICON_NAMES.SHEVRONS_LEFT}
            disabled={prevFileDis}
            onClick={showPrevFile}
            classNameBtn="iconBtn-border"
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
          {!noInDocPageNavigation && (
            <>
              <GoToPreviousPage>
                {props => (
                  <IconButton
                    ariaLabel="Go to previous page"
                    nameIcon={ICON_NAMES.SHEVRON_LEFT}
                    disabled={props.isDisabled}
                    onClick={props.onClick}
                    classNameBtn="iconBtn-border"
                    uiPermissionType={UI_PERMISSION_TYPE.READABLE}
                  />
                )}
              </GoToPreviousPage>
              <GoToNextPage>
                {props => (
                  <IconButton
                    ariaLabel="Go to next page"
                    nameIcon={ICON_NAMES.SHEVRON_RIGHT}
                    disabled={props.isDisabled}
                    onClick={props.onClick}
                    classNameBtn="iconBtn-border"
                    uiPermissionType={UI_PERMISSION_TYPE.READABLE}
                  />
                )}
              </GoToNextPage>
            </>
          )}

          <IconButton
            nameIcon={ICON_NAMES.SHEVRONS_RIGHT}
            disabled={nextFileDis}
            onClick={showNextFile}
            classNameBtn="iconBtn-border"
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
        </div>
      </div>
      {/* <div style={{position:"absolute", bottom:'1em', right:'0'}}><EnterFullScreenButton /></div>  */}
      {!props?.isDownloadDisabled && !props?.needToUpdate && (
        <Download>
          {props => (
            <div
              className="doc_view__download pdf pr"
              // onClick={props.onClick}
              style={{bottom: iconsBottomPositionValue}}
            >
              <IconButton
                ariaLabel="Download"
                nameIcon={ICON_NAMES.DOWNLOAD_CLOUD}
                tooltipMessage="Download"
                onClick={props.onClick}
                uiPermissionType={UI_PERMISSION_TYPE.READABLE}
              />
            </div>
          )}
        </Download>
      )}
      {props?.shareBtnEnable && !props?.needToUpdate && (
        <div
          className=""
          onClick={props.onClick}
          style={{position: "absolute", bottom: iconsBottomPositionValue, right: "4em", zIndex: "100"}}
        >
          <ShareButton
            fileArray={fileArray}
            fileName={fileName || entityName}
            entityId={entityId}
            entityName={entityName}
          />
        </div>
      )}
      {props?.printBtnEnable && !props?.needToUpdate && (
        <Print>
          {props => (
            <div
              className="doc_view__print pdf pr"
              style={{position: "absolute", bottom: iconsBottomPositionValue, right: "6.3rem", zIndex: "100"}}
            >
              <IconButton
                ariaLabel="Print"
                nameIcon={ICON_NAMES.PRINTER}
                tooltipMessage="Print"
                onClick={props.onClick}
                uiPermissionType={UI_PERMISSION_TYPE.READABLE}
              />
            </div>
          )}
        </Print>
      )}
    </>
  );
};

const RenderFullScreenPdf = props => {
  const {file, isDownloadDisabled, waterMarkText, waterMarkShow, waterMarkColor, needToUpdate} = props;
  const toolbarPluginInstance = toolbarPlugin();
  const {Toolbar} = toolbarPluginInstance;

  const renderError = ({
    message,
    // name
  }) => {
    return <p className="label error_doc_view">{message}</p>;
  };
  return (
    <>
      <Toolbar>
        {props => {
          const {
            CurrentPageInput,
            Download,
            // GoToNextPage,
            // GoToPreviousPage,
            NumberOfPages,
            // Print,
            // ShowSearchPopover,
            Zoom,
            ZoomIn,
            ZoomOut,
          } = props;
          return (
            <div className="w100 row sticky pt5 mt5 mb5" style={{backgroundColor: "white", zIndex: 2, top: "-2px"}}>
              {/* <div style={{padding: "0px 2px"}}>
                <ShowSearchPopover />
              </div> */}
              <div className="row gap">
                <div style={{padding: "0px 2px"}}>
                  <ZoomOut />
                </div>
                <div style={{padding: "0px 2px"}}>
                  <Zoom />
                </div>
                <div style={{padding: "0px 2px"}}>
                  <ZoomIn />
                </div>
              </div>

              {/* <div style={{padding: "0px 2px", marginLeft: "auto"}}>
                <GoToPreviousPage />
              </div> */}
              <div
                style={{
                  padding: "0px 2px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CurrentPageInput /> / <NumberOfPages />
              </div>
              {/* <div style={{padding: "0px 2px"}}>
                <GoToNextPage />
              </div> */}
              {!isDownloadDisabled && !needToUpdate && (
                <div style={{padding: "0px 2px"}}>
                  <Download />
                </div>
              )}

              {/* <div style={{padding: "0px 2px"}}>
                <Print />
              </div> */}
            </div>
          );
        }}
      </Toolbar>
      <div className="overflowY asc" style={{position: "relative", width: "70vw", maxHeight: "80vh"}}>
        {waterMarkShow && (
          <div
            style={{
              position: "absolute",
              top: "20%",
              left: "85%",
              transform: "translate(-80%, -15%) scale(1.5)",
              zIndex: 10,
              width: "100%",
            }}
          >
            <WaterMark text={waterMarkText} style={{color: waterMarkColor}} />
          </div>
        )}
        <Viewer
          fileUrl={file}
          defaultScale={SpecialZoomLevel.PageWidth}
          scrollMode={ScrollMode.Vertical}
          plugins={[toolbarPluginInstance]}
          renderError={renderError}
          renderLoader={() => <Spinner />}
        />
      </div>
    </>
  );
};

export default NewPdfViewer;
